import { Link, useNavigate } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Overview page components
import Header from "layouts/profile/components/Header";

// Images
import homeDecor1 from "assets/images/home-decor-1.jpg";

import { useEffect, useState } from "react";
import { getContents } from "service/admin";
import { postContents } from "service/admin";
import { createUser } from "service/admin";
import { getUserRole } from "service/admin";
import { InputLabel, MenuItem, Select } from "@mui/material";

function AdminCreate() {
  const { articledata, setArticleData } = useState([]);
  const { role, setRole } = useState([]);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "", // Default type
    phone_number: "",
    address: "",
    avatar: "",
    password: "",
    role_id: 1,
  });

  useEffect(() => {
    userRole();
  }, []);

  const userRole = async () => {
    try {
      const res = await getUserRole();
      if (res.data.status == 200) {
        setRole(res.data.data);
      }
    } catch (err) {}
  };

  // Step 2: Handle form input changes
  const handleChange = (event) => {
    console.log(event);
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  console.log(formData);

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    postArticleData();
  };
  const postArticleData = async () => {
    try {
      const users = await createUser(formData);
      if (users.data.status == 200) {
        navigate("/admin-users");
        setArticleData(users.data.data);
      }
    } catch (err) {}
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header>
        <MDBox pt={2} px={2} lineHeight={1.25}>
          <MDTypography variant="h3" fontWeight="medium">
            Create New Admin User
          </MDTypography>

          <MDBox mb={1}>
            <MDBox
              width="100%"
              component="form"
              method="post"
              autoComplete="off"
              onSubmit={handleSubmit}
            >
              <MDBox p={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={8}>
                    <MDInput
                      name="first_name"
                      variant="standard"
                      label="first Name"
                      fullWidth
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <MDInput
                      name="last_name"
                      variant="standard"
                      label="last Name"
                      fullWidth
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <MDInput
                      name="email"
                      variant="standard"
                      label="email"
                      fullWidth
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <MDInput
                      name="phone_number"
                      variant="standard"
                      label="phone number"
                      fullWidth
                      onChange={handleChange}
                    />
                  </Grid>
                  {/* <Grid item xs={12} md={8}>
                    <MDInput
                      name="address"
                      variant="standard"
                      label="address"
                      fullWidth
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <MDInput
                      name="avatar"
                      variant="standard"
                      label="avatar"
                      fullWidth
                      onChange={handleChange}
                    />
                  </Grid> */}
                  <Grid item xs={12} md={8}>
                    <FormControl fullWidth variant="standard">
                      <InputLabel id="demo-simple-select-helper-label">Role</InputLabel>
                      <Select
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        label="role_id"
                        name="role_id"
                        onChange={handleChange}
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        <MenuItem value={1}>Admin</MenuItem>
                        <MenuItem value={2}>Parent</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <MDInput
                      type="password"
                      name="password"
                      variant="standard"
                      label="password"
                      fullWidth
                      onChange={handleChange}
                    />
                  </Grid>

                  {/* <Grid item xs={12} md={8}>
                    <FormControl>
                      <FormLabel
                        id="demo-row-radio-buttons-group-label"
                        style={{ fontSize: "14px" }}
                      >
                        Type
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="type"
                        label="Type"
                        onChange={handleChange}
                      >
                        <FormControlLabel
                          value="mrk"
                          control={<Radio />}
                          label="Marketing"
                          checked={formData.type === "mrk"}
                        />
                        <FormControlLabel value="edu" control={<Radio />} label="Educational" />
                      </RadioGroup>
                    </FormControl>
                  </Grid> */}
                </Grid>
                <Grid
                  container
                  item
                  justifyContent="center"
                  xs={12}
                  my={2}
                  style={{ padding: "5px" }}
                >
                  <MDButton variant="gradient" color="secondary" component={Link} to="/admin-users">
                    Cancel
                  </MDButton>
                  <MDButton type="submit" variant="gradient" color="success">
                    Save
                  </MDButton>
                </Grid>
              </MDBox>
            </MDBox>
          </MDBox>
        </MDBox>
        <br />
      </Header>
      <MDBox p={2}>
        <Grid container spacing={6}></Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default AdminCreate;
